import { Color } from '../common/color.model';
import { ShotType } from '../common/shot-type.model';
import { Style } from '../common/style.model';
import { MediaFormat } from '../common/media-format.type';

export class Template {
  public parentTemplateId: number;
  public templateName: string;
  public brandId: number;
  public brandName: string;
  public hasSizeGroup: boolean;
  public categoryId: number;
  public shotsNumber: number;
  public categoryName: string;
  public styles: Style[];
  public colors: Color[];
  public shotTypes: TemplateShotType[];

  public inEditing?: boolean;
  public isVisible?: boolean;
  public openedDetails?: boolean;

  constructor(init?: Partial<Template>) {
    Object.assign(this, init);
  }
}


export class TemplateShotType {
  public sizeGroupId: number;
  public sizeGroupName: string;

  public shotTypeId: number;
  public shotTypeCode: string;
  public shotTypeName: string;

  public mediaFormatId?: number;
  public aspectRatioId?: number

  public codifiedUsedId?: number;
  public codifiedUsedCode?: string;
  public codifiedUsedName?: string;

  public sizeIndex?: number;
  public showOptions?: boolean;
  public showCodifiedUsedsOptions?: boolean;
  public showFormat?: boolean;
  public showAspectRatio?: boolean;


  constructor(init?: Partial<TemplateShotType>) {
    Object.assign(this, init);
  }
}
